import { render, staticRenderFns } from "./communityIssueType.vue?vue&type=template&id=17689709&scoped=true&"
import script from "./communityIssueType.vue?vue&type=script&lang=js&"
export * from "./communityIssueType.vue?vue&type=script&lang=js&"
import style0 from "./communityIssueType.vue?vue&type=style&index=0&id=17689709&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17689709",
  null
  
)

export default component.exports